import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

@Component({
  selector: 'app-b2b-privacy-policy',
  templateUrl: './b2b-privacy-policy.component.html',
})
export class B2bPrivacyPolicyComponent implements OnInit {

  version = environment.version;

  constructor() { }

  ngOnInit(): void {
  TraceXInterceptor.interceptTrace('dashboard/src/app/modules/b2b-privacy-policy/b2b-privacy-policy.component.ts.B2bPrivacyPolicyComponent.ngOnInit');
  }

}
